import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <Center mih={360}>
      <Stack align="center" gap="sm">
        <Title order={1}>404</Title>
        <Text c="dimmed">That page doesn't exist here.</Text>
        <Button component={Link} to="/" variant="default">
          Back to overview
        </Button>
      </Stack>
    </Center>
  );
}
